// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__vesperlibre_f3c884', '__vesperlibre_Fallback_f3c884', s, a, n, s, -, s, e, r, i, f","fontStyle":"normal"},"className":"__className_f3c884"};